import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Logo from "shared/Logo/Logo";
import { Link } from "react-router-dom";
import { NavItemType } from "./NavigationItem";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import companyLogo from "images/logo.png";
import SocialsList from "shared/SocialsList/SocialsList";
import { AuthContext } from "context/authenticate";
import { Menu } from 'antd';
import { TokenLocalStorageKey } from "utils/constant";

export interface NavMobileProps {
    navigationList: any[];
    currentKey: string;
    data?: NavItemType[];
    onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { navigationList, currentKey, onClickClose } = props;
    const { userInfo } = useContext(AuthContext);

    const onProfileButtonClick = () => {
        history.push('/account');
    }

    const onLogoutButtonClick = () => {
        window.localStorage.setItem(TokenLocalStorageKey, '');
        window.location.href = '/';
    }

    return (
        <div className="flex flex-col w-full max-w-sm h-full max-h-[100dvh] py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
            <div className="relative shrink-0 py-6 px-5">
                <Logo img={companyLogo} homePageUrl={'/'} className="flex justify-center" />
                <div className="flex flex-col mt-5 text-neutral-700 dark:text-neutral-300 text-sm">
                    <span></span>
                    <div className="flex justify-center items-center mt-4">
                        <SocialsList itemClass="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 text-xl dark:bg-neutral-800 dark:text-neutral-300" />
                    </div>
                </div>
                <span className="absolute right-2 top-2 p-1">
                    <ButtonClose onClick={onClickClose} />
                </span>
            </div>
            <div className="flex min-h-0 flex-1 flex-col overflow-y-auto py-6 px-2 space-y-1">
                <Menu mode="inline" selectedKeys={[currentKey]} className="w-full">
                    {
                        navigationList.map(item => (
                            <Menu.Item key={item.key} className="text-[18px]">
                                <Link to={item.link}>{item.name}</Link>
                            </Menu.Item>
                        ))
                    }
                </Menu>
            </div>
            <div className="flex shrink-0 flex-col items-center justify-center py-6 px-5 pb-[max(1.5rem,env(safe-area-inset-bottom))] space-x-4">
                <ButtonPrimary href="/cart" onClick={onClickClose}>
                    {t('cart.link_to_cart')}
                </ButtonPrimary>
                {
                    !userInfo?.id
                        ? (<ButtonPrimary href="/login" onClick={onClickClose} className="!ml-0 mt-[12px]">
                            {t('coupon.login')}
                        </ButtonPrimary>)
                        : (<>
                            <ButtonPrimary onClick={onProfileButtonClick} className="!ml-0 mt-[12px]">
                                {t('user.profile')}
                            </ButtonPrimary>
                            <ButtonPrimary onClick={onLogoutButtonClick} className="!ml-0 mt-[12px]">
                                {t('user.logout')}
                            </ButtonPrimary>
                        </>)
                }
            </div>
        </div>
    );
};

export default NavMobile;